import * as React from 'react';

import {
  LinePlotLegendWarningView,
  type LinePlotLegendWarningViewProps,
} from './LinePlotLegendWarningView';
import {useLinePlotSettings} from './LinePlotSettingsContext';

type LinePlotLegendWarningProps = Omit<
  LinePlotLegendWarningViewProps,
  'groupingDepth' | 'isFullFidelity' | 'isGrouped' | 'maxRuns'
>;

/**
 * Reads the panel's grouping and config settings and renders
 * LinePlotLegendWarningView, which decides which warning to show.
 */
export const LinePlotLegendWarning = React.memo(function LinePlotLegendWarning(
  props: LinePlotLegendWarningProps
) {
  const {groupingDepth, isAnyRunsetGrouped, isFullFidelity, limit} =
    useLinePlotSettings();

  return (
    <LinePlotLegendWarningView
      {...props}
      groupingDepth={groupingDepth}
      isFullFidelity={isFullFidelity}
      isGrouped={isAnyRunsetGrouped}
      maxRuns={limit}
    />
  );
});

LinePlotLegendWarning.displayName = 'LinePlotLegendWarning';
